import type { Variant } from '@storefront/lib-global/codegen/types';
import { StockStatus } from '@storefront/lib-global/codegen/types';

export const isOutOfStock = (size: string, width: string, variants: Variant[]): boolean => {
  const filteredVariants = variants.filter(
    (variant) => (size ? variant.size === size : true) && (width ? variant.fitLabel === width : true),
  );

  return filteredVariants.every((v) => v.stock.status === StockStatus.OUTOFSTOCK);
};
